import React from 'react';
import Header from '../../components/Layout/Header';
import Footer from '../../components/Layout/Footer';
import TermsMain from './TermsMain';
import BackToTop from '../../components/elements/BackToTop';

const Terms = () => {
    return (
        <React.Fragment>
            <Header />
            <TermsMain />
            <Footer />
            <BackToTop />
        </React.Fragment>
    );
}

export default Terms;